import React, {useEffect, useState} from 'react';
import Alert from '@mui/material/Alert';
import AlertTitle from "@mui/material/AlertTitle";
import {Typography, Row, Col, Card, Layout} from 'antd';
import ExposureBarChart from "./components/ExposureBarChart";
import ExposureBubbleChart from "./components/ExposureBubbleChart";
import ExposureTable from "./components/ExposureTable";
import Orientation from "../../../../Components/Orientation";


const _OrientText = ()=>(<span>
  The max exposures shows the "Max Potential Exposure" any ticker can undergo within the portfolio without
    regard to any other tickers within the portfolio. The bars represent the max weight absolute, while the scatter below
    shows the current positioning for max potential weight
</span>);


let _maxPerSymbolToChart = (o)=>{
    let a = [];
    for (let k in o){
        if (o[k] > 0) {
            a.push({
                x: k.toUpperCase(), value: (o[k] * 100).toFixed(1),
                normal:{label: {enabled: true}}
            })
        }
    }
    a.sort((_a, _b)=>{return _b.value-_a.value});
    return a;
}


let getMaxPerSymbol = (tree, {symbols={}, weightFactor=1}={})=>{
    for (let k in tree){
        if (tree[k].hasOwnProperty('tree')){
            getMaxPerSymbol(tree[k].tree, {
                symbols: symbols,
                weightFactor: weightFactor * tree[k].wgt
            });
        }
        else{
            if (!symbols.hasOwnProperty(k)){
                symbols[k] = 0;
            }
            if (tree[k].wgt === 0 || weightFactor < 1) {
                symbols[k] += weightFactor;
            }
            else if (tree[k].wgt > 0 && weightFactor === 1){
                // Best guess here is a static holding. We need a way to check if previous was leaderboard
                symbols[k] += tree[k].wgt
            }
        }
    }
    return _maxPerSymbolToChart(symbols);
}


const MaxExposure = ({ treeData, symbols, showOrient=false }) => {
  const maxExposureData = getMaxPerSymbol(treeData);
  const currentWeights = symbols;
  const [orientVisible, setOrientVisible] = useState(localStorage.getItem('ptflview_allocations_orient_1') || true);

  useEffect(() => {
      return () => {setOrientVisible(false)}}, []);
  return (
    <Layout>
        <Layout.Sider style={{background: "#fff"}} width={500}>
            <ExposureTable maxExposureData={maxExposureData} currentWeights={currentWeights} />
        </Layout.Sider>
        <Layout.Content>
            <div style={{maxWidth: 1000, margin: 'auto'}}>
                <Card bordered={false}>
                    <ExposureBarChart maxExposureData={maxExposureData} />
                </Card>
                <div style={{height: '300px', width: '100%'}}>
                    <ExposureBubbleChart maxExposureData={maxExposureData} currentWeights={currentWeights} />
                </div>
            </div>
        </Layout.Content>
        {showOrient&&(
            <Orientation
                title="Max Exposure"
                visible={orientVisible}
                onToggle={setOrientVisible}
                children={<>
                    <_OrientText/>
                </>}
            />
        )}
    </Layout>
  );
};

export default MaxExposure;